import { render } from "./VerificaEmail.vue?vue&type=template&id=4f51ab5e&scoped=true"
import script from "./VerificaEmail.vue?vue&type=script&lang=js"
export * from "./VerificaEmail.vue?vue&type=script&lang=js"

import "./VerificaEmail.vue?vue&type=style&index=0&id=4f51ab5e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f51ab5e"]])

export default __exports__